export const helpPage = (url) => {
  if (url.includes("organization/profile")) {
    return "https://help.trainery.one/organization/profile/dashboard";
  } else if (url.includes("track/learner-board")) {
    return "https://help.trainery.one/trak/traklearning/learner-board";
  } else if (url.includes("track/work-roles")) {
    return "https://help.trainery.one/trak/traklearning/work-roles-2";
  } else if (url.includes("track/courses")) {
    return "https://help.trainery.one/trak/traklearning/courses-2";
  } else if (url.includes("track/learning-records")) {
    return "https://help.trainery.one/trak/traklearning/training-record-2";
  } else if (url.includes("track/learning-matrix")) {
    return "https://help.trainery.one/trak/traklearning/matrix-2";
  } else if (url.includes("trakevents/learning-events")) {
    return "https://help.trainery.one/trak/traklearning/event-2";
  } else {
    return "https://help.trainery.one/core";
  }
};
